import React, { useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { DetailLayout } from 'components/DetailLayout';
import LayoutTile from 'components/LayoutTile';
import Typography from 'components/Typography';
import { translate } from 'i18n';
import { useAuthentication } from 'state/Authentication';
import EmailPending from '../EmailPending';

interface ReadOnlyURLSearchParams extends URLSearchParams {
  append: never;
  set: never;
  delete: never;
  sort: never;
}

const Email: React.FC = () => {
  const {
    state: { user, eID },
  } = useAuthentication();
  const history = useHistory();
  const { search } = useLocation();
  /* eslint-disable-next-line prettier/prettier */
  const searchParams = useMemo(() => new URLSearchParams(search) as ReadOnlyURLSearchParams, [search]);

  React.useEffect(() => {
    if (user.emailPrimary || user.email?.candidate || searchParams.get('candidate')) return;

    history.replace('/gegevens/aanmeldsleutels/e-mail/toevoegen');
  }, [user]);

  const canRemoveEmail = useMemo(() => {
    if (user.phonePrimary || eID?.rrnr) return true;

    return false;
  }, [user]);

  if (user.email?.candidate || searchParams.get('candidate')) {
    return <EmailPending />;
  }

  if (!user.emailPrimary) {
    return <EmailPending />;
  }

  return (
    <DetailLayout
      backAction="/gegevens"
      backLabel="accessKeys.overview.title"
      title="accessKeys.email.title"
      description="accessKeys.email.intro"
    >
      <LayoutTile
        label={translate('accessKeys.email.update')}
        to="/gegevens/aanmeldsleutels/e-mail/wijzigen"
        toLabel={translate('accessKeys.email.update')}
        value={user.emailPrimary}
      />

      <LayoutTile
        label={translate('accessKeys.password.update')}
        to="/gegevens/aanmeldsleutels/wachtwoord/wijzigen"
        toLabel={translate('accessKeys.password.update')}
        value="*********"
      />

      <LayoutTile
        label={translate('accessKeys.email.delete')}
        to="/gegevens/aanmeldsleutels/e-mail/verwijderen"
        toLabel={translate('accessKeys.email.delete')}
        description={translate('accessKeys.email.delete.description')}
        disabled={!canRemoveEmail}
        variant="danger"
        classNames="u-margin-top-xs"
      />

      {!canRemoveEmail && (
        <Typography classNames="u-text-light u-margin-top-xs">
          {translate('accessKeys.email.delete.prohibited')}
        </Typography>
      )}
    </DetailLayout>
  );
};

export default Email;
